const ActionTypes = {
  CREATE_ACTION: 'create', 
  COPY_ACTION: 'copy',
  EDIT_ACTION: 'edit'
};

export default ActionTypes;